import {
  DataGrid,
  List,
  LoadPanel,
  SelectBox,
  Template,
} from "devextreme-react";
import {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
  Lookup,
  Editing,
} from "devextreme-react/data-grid";
import React, {
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import Modal from "react-modal";
import DropDownBox from "devextreme-react/drop-down-box";
import { getRequestParams } from "../../helpers/globalfunctions";
import { DateFormat, RegEx } from "../../helpers/fixcodes";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Map from "devextreme-react/map";
import GooglePlaceSearchComponent from "../Shared/GooglePlaceSearchComponent";
import { useMemo } from "react";
import DataSource from "devextreme/data/data_source";
import {
  askConfirmation,
  showResponseMessageWithErrorInToast,
} from "../../helpers/message";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import UserActivityHistoryComponent from "../Shared/UserActivityHistoryComponent";
import SetDefaultHotelComponent from "../Shared/SetDefaultHotelComponent.js";

export default function NonFlyActivityLocationComponent() {
  const [state, setState] = useState({
    loadPanelVisible: false,
    filterDropdownAirportDataSource: [],
    filterAirportCode: "",
    nonFlyActivityLocationGridDataSource: [],
    openActivityLocationModal: false,
    openActivityLocationMappingModal: false,
    locationCode: "",
    mappedAirportCodes: [],
    historyModal: {
      openModal: false,
      airlineCode: "",
      locationCode: "",
      displayTitle: "",
    },
    isSetDefaultHotelModalOpen: false,
    rowData: null,
  });
  const refDataGrid = useRef(null);
  useLayoutEffect(() => {
    document.querySelector(
      "#lblPageTitle"
    ).innerHTML = `Crew - Non Fly Activity Location`;
  }, []);
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetGridDataOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  const fetGridDataOnPageLoad = () => {
    try {
      setTimeout(() => {
        getDropdownAirportDataSource();
      }, 0);
      setTimeout(async () => {
        await getNonFlyActivityLocationList();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const getDropdownAirportDataSource = useCallback(async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let url = `${
        process.env.REACT_APP_API_BASE_URL
      }Airport/get-airport-dropdown/${sessionStorage.getItem(
        "session_airlineCode"
      )}`;
      const res = await fetch(url, getRequestParams("GET")).then((response) =>
        response.json()
      );
      setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: res.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  }, []);
  const getNonFlyActivityLocationList = async () => {
    try {
      refDataGrid.current.instance.beginCustomLoading();
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let airportCode = state.filterAirportCode ?? "";
      let apiUrl = `${process.env.REACT_APP_API_BASE_URL}CrewActivity/get-non-fly/activity-locations`;
      let res = await fetch(
        apiUrl,
        getRequestParams("POST", {
          AirlineCode: airlineCode,
          AirportCode: airportCode,
        })
      );
      let resp = await res.json();
      setState((prev) => ({
        ...prev,
        nonFlyActivityLocationGridDataSource: resp.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid.current.instance.endCustomLoading();
    }
  };

  const handleOnCloseSetDefaultHotelModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isSetDefaultHotelModalOpen: false,
        rowData: null,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const renderGridCell = (data) => {
    let updateLink = (
      <a
        href="#"
        title="Update Activity Location"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            openActivityLocationModal: true,
            locationCode: data.data.locationCode,
          }));
        }}
        className="btn-link"
      >
        <i className="fas fa-edit"></i>
      </a>
    );
    let mappingLink = (
      <a
        href="#"
        title="Update Activity Location Mapping"
        style={{ cursor: "pointer", paddingLeft: "6px" }}
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            openActivityLocationMappingModal: true,
            locationCode: data.data.locationCode,
            mappedAirportCodes: data.data.mappedAirportCodes,
          }));
        }}
        className="btn-link"
      >
        <i className="fas fa-cog"></i>
      </a>
    );
    let setDefaultLink = (
      <a
        href="#"
        title="Set Default Link"
        style={{ cursor: "pointer", paddingLeft: "6px" }}
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            isSetDefaultHotelModalOpen: true,
            rowData: data?.data,
          }));
        }}
        className="btn-link"
      >
        <i className="fas fa-hotel"></i>
      </a>
    );

    let activityHistory = (
      <a
        href="#"
        title="Log"
        onClick={(e) => {
          debugger;
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            historyModal: {
              openModal: true,
              airlineCode: data.data.airlineCode,
              locationCode: data.data.locationCode,
              displayTitle: data.data.locationCode,
            },
          }));
        }}
        className="btn-link"
      >
        <i
          style={{ cursor: "pointer", marginLeft: "6px" }}
          className="fas fa-exclamation-circle"
        />
      </a>
    );

    return (
      <div style={{ textAlign: "left" }}>
        {updateLink}
        {mappingLink}
        {activityHistory}
        {setDefaultLink}
      </div>
    );
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div>
            <DataGrid
              ref={refDataGrid}
              dataSource={state.nonFlyActivityLocationGridDataSource}
              columnsAutoWidth={true}
              showColumnLines={true}
              showRowLines={true}
              showBorders={true}
              rowAlternationEnabled={false}
              allowColumnResizing={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    template: "toolbarAirportDropdown",
                  },
                  {
                    location: "before",
                    template: "toolbarFilterCrewLocation",
                  },
                  {
                    location: "after",
                    template: "toolbarAddCrewLocation",
                  },
                  {
                    location: "after",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      onClick: async () => {
                        await getNonFlyActivityLocationList();
                      },
                    },
                  }
                );
              }}
            >
              <Template
                name="toolbarAirportDropdown"
                render={() => {
                  return (
                    <>
                      <SelectBox
                        dataSource={state.filterDropdownAirportDataSource}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Airport"
                        name="airportCode"
                        value={state.filterAirportCode}
                        displayExpr="airportName"
                        valueExpr="airportCode"
                        width={400}
                        height={35}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        onValueChanged={(e) => {
                          setState((prev) => ({
                            ...prev,
                            filterAirportCode: e.value ?? "",
                          }));
                        }}
                      />
                    </>
                  );
                }}
              />
              <Template
                name="toolbarFilterCrewLocation"
                render={() => {
                  return (
                    <>
                      <button
                        type="button"
                        title="Search Location"
                        className="btn btn-primary"
                        onClick={async () => {
                          await getNonFlyActivityLocationList();
                        }}
                      >
                        <i
                          className={`fas fa-${
                            state.isLoading ? "spinner fa-spin" : "check"
                          }`}
                        />
                        &nbsp;&nbsp;Filter
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarAddCrewLocation"
                render={() => {
                  return (
                    <>
                      <button
                        type="button"
                        title="Add Location"
                        className="btn btn-primary"
                        onClick={() => {
                          setState((prev) => ({
                            ...prev,
                            openActivityLocationModal: true,
                          }));
                        }}
                      >
                        <i
                          style={{ cursor: "pointer" }}
                          className="fas fa-plus"
                        />
                        &nbsp;&nbsp;Add Location
                      </button>
                    </>
                  );
                }}
              />
              <Column
                dataField="rowIndex"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowExporting={false}
                allowFiltering={false}
                cellRender={renderGridCell}
                fixed={true}
                width={"auto"}
              />
              <Column
                dataField="locationCode"
                caption="Location Code"
                allowFiltering={false}
                allowSearch={true}
                width={150}
              />
              <Column
                dataField="airportCode"
                caption="Airport Code"
                allowFiltering={false}
                allowSearch={true}
                width={100}
              />
              <Column
                dataField="addressTitle"
                caption="Address Title"
                allowFiltering={false}
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="address"
                caption="Address"
                allowFiltering={false}
                allowSearch={true}
                width={350}
                cellRender={(data) => {
                  return (
                    <div className="mergeData ellipsis">
                      <span className="text-danger">
                        <i className="fas fa-map-marker-alt"></i>
                      </span>
                      <span className="text-muted"></span> {"  "}
                      {data.data.address}
                      <br />
                      <span className="text-success">
                        <i className="fas fa-map-marker-alt"></i>
                      </span>
                      <span className="text-muted"></span>
                      {"  "}
                      <a
                        href="#"
                        title="Navigate to maps"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            `https://maps.google.com?q=${data.data.latitude} , ${data.data.longitude}`
                          );
                        }}
                      >
                        {" "}
                        {`${data.data.latitude} , ${data.data.longitude}`}
                      </a>
                    </div>
                  );
                }}
              />
              <Column
                dataField="landmark"
                caption="Landmark"
                allowFiltering={false}
                allowSearch={true}
                width={150}
              />
              <Column
                dataField="city"
                caption="City"
                allowFiltering={false}
                allowSearch={true}
                width={100}
              />
              <Column
                dataField="state"
                caption="State"
                allowFiltering={false}
                allowSearch={true}
                width={100}
              />
              <Column
                dataField="country"
                caption="Country"
                allowFiltering={false}
                allowSearch={true}
                width={100}
              />
              <Column
                dataField="postalCode"
                caption="Postal Code"
                allowFiltering={false}
                allowSearch={true}
                width={100}
              />
              <Column
                dataField="activeStatus"
                caption="Status"
                allowFiltering={false}
                allowSearch={true}
                width={100}
              />
              <Column
                dataField="modifiedDate"
                caption="Date"
                allowFiltering={false}
                allowSearch={true}
                format={DateFormat.DateTime24NorthFormat}
                dataType="datetime"
                width={100}
              />
              <SortByGroupSummaryInfo summaryItem="count" />
              <GroupPanel visible={false} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Grouping autoExpandAll={true} />
              <Paging defaultPageSize={10} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="NonFlyActivityLocation"
              />
            </DataGrid>
          </div>
        </div>
      </div>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />

      {state.openActivityLocationModal && (
        <SaveActivityLocationComponent
          locationCode={state.locationCode}
          onRefresh={async () => {
            await getNonFlyActivityLocationList();
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openActivityLocationModal: false,
              locationCode: "",
            }));
          }}
        />
      )}

      {state.openActivityLocationMappingModal && (
        <SaveActivityLocationMappingModal
          locationCode={state.locationCode}
          mappedAirportCodes={state.mappedAirportCodes}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openActivityLocationMappingModal: false,
            }));
          }}
        />
      )}

      {state.historyModal.openModal && (
        <UserActivityHistoryComponent
          airlineCode={state.historyModal.airlineCode}
          displayTitle={state.historyModal.displayTitle}
          columnValue1={state.historyModal.locationCode}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              historyModal: {
                openModal: false,
                airlineCode: "",
                displayTitle: "",
                hotelCode: "",
              },
            }));
          }}
        />
      )}

      {state.isSetDefaultHotelModalOpen && (
        <SetDefaultHotelComponent
          code={state.rowData?.locationCode}
          fromAirport={false}
          rowData={state.rowData}
          onRefresh={async () => {
            await getNonFlyActivityLocationList();
          }}
          onClose={() => {
            handleOnCloseSetDefaultHotelModal();
          }}
        />
      )}
    </>
  );
}
const SaveActivityLocationComponent = memo((props) => {
  const [mappedAirportCodes, setMappedAirportCodes] = useState([]);
  const [state, setState] = useState({
    loadPanelVisible: false,
    dropdownAirportDataSource: [],
    dutyLocatonId: 0,
    locationCode: "",
    addressTitle: "",
    address: "",
    landmark: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    latitude: 0.7893,
    longitude: 113.9213,
    errors: {
      airportCode: "",
      locationCode: "",
      addressTitle: "",
      address: "",
      landmark: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      latitude: "",
      longitude: "",
    },
    isLocationSubmitted: false,
    openGooglePlaceSearchModal: false,
  });
  const center = useMemo(
    () => ({
      lat: state.latitude,
      lng: state.longitude,
    }),
    [state.latitude, state.longitude]
  );
  const refLstAirport = useRef(null);
  const getDropdownAirportDataSource = async () => {
    let airportCodeDropdownLst = [];
    try {
      let url = `${
        process.env.REACT_APP_API_BASE_URL
      }Airport/get-airport-dropdown/${sessionStorage.getItem(
        "session_airlineCode"
      )}`;
      const res = await fetch(url, getRequestParams("GET")).then((response) =>
        response.json()
      );
      airportCodeDropdownLst = [...new Set(res.payload ?? [])];
    } catch (error) {
      console.log(error);
    }
    return airportCodeDropdownLst;
  };
  const fetchApiOnPageLoad = async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let airportCodeDropdownLst = await getDropdownAirportDataSource();
      let data = null;
      if (props.locationCode) {
        let airlineCode = sessionStorage.getItem("session_airlineCode");
        let apiUrl = `${process.env.REACT_APP_API_BASE_URL}CrewActivity/get-non-fly/activity-locations`;
        let res = await fetch(
          apiUrl,
          getRequestParams("POST", {
            AirlineCode: airlineCode,
            LocationCode: props.locationCode ?? "",
          })
        ).then((res) => res.json());
        data = res.payload?.[0] ?? null;
      }
      let mappedAirportCodes =
        data?.mappedAirportCodes?.map((code) => code.trim()) ?? [];

      let mappedAirportCodeLst = [
        ...new Set(
          mappedAirportCodes.map((code) => {
            return {
              airportCode: code.trim(),
              airportName:
                airportCodeDropdownLst.filter(
                  (el) => el.airportCode.trim() === code.trim()
                )?.[0]?.airportName ?? "",
              isMapped: 1,
            };
          })
        ),
      ];
      let unMappedAirportCodeLst = [
        ...new Set(
          airportCodeDropdownLst
            .filter((el) => {
              return !mappedAirportCodes.find((code) => {
                return code.trim() === el.airportCode.trim();
              });
            })
            .map((item) => ({
              ...item,
              isMapped: 0,
            }))
        ),
      ];
      let airportCodeDropdown = [
        ...mappedAirportCodeLst,
        ...unMappedAirportCodeLst,
      ];
      setMappedAirportCodes(mappedAirportCodes);
      setState((prev) => ({
        ...prev,
        dropdownAirportDataSource: airportCodeDropdown,
        dutyLocatonId: data?.rowIndex ?? 0,
        locationCode: data?.locationCode ?? "",
        addressTitle: data?.addressTitle ?? "",
        address: data?.address ?? "",
        landmark: data?.landmark ?? "",
        city: data?.city ?? "",
        state: data?.state ?? "",
        country: data?.country ?? "",
        postalCode: data?.postalCode ?? "",
        latitude: data?.latitude ?? "",
        longitude: data?.longitude ?? "",
        errors: {
          airportCode: "",
          locationCode: "",
          addressTitle: "",
          address: "",
          landmark: "",
          city: "",
          state: "",
          country: "",
          postalCode: "",
          latitude: "",
          longitude: "",
        },
      }));
      setTimeout(() => {
        if (refLstAirport?.current?.instance) {
          refLstAirport.current.instance.option(
            "selectedItemKeys",
            mappedAirportCodes
          );
        }
      }, 500);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let err = state.errors;
    switch (name) {
      case "locationCode":
        err.locationCode = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, locationCode: value }));
        }
        break;
      case "airportCode":
        err.airportCode = "";
        if (value.trim() === "" || value.length <= 10) {
          setState((prev) => ({ ...prev, airportCode: value }));
        }
        break;
      case "addressTitle":
        err.addressTitle = "";
        if (value.trim() === "" || value.length <= 100) {
          setState((prev) => ({ ...prev, addressTitle: value }));
        }
        break;
      case "landmark":
        err.landmark = "";
        if (value.trim() === "" || value.length <= 100) {
          setState((prev) => ({ ...prev, landmark: value }));
        }
        break;
      case "latitude":
        err.latitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          setState((prev) => ({ ...prev, latitude: value }));
        }
        break;
      case "longitude":
        err.longitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          setState((prev) => ({ ...prev, longitude: value }));
        }
        break;
      case "cityName":
        err.city = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, city: value }));
        }
        break;
      case "stateName":
        err.state = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, state: value }));
        }
        break;
      case "countryName":
        err.country = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, country: value }));
        }
        break;
      case "address":
        err.address = "";
        if (value.trim() === "" || value.length <= 250) {
          setState((prev) => ({ ...prev, address: value }));
        }
        break;

      default:
        break;
    }
    setState((prev) => ({
      ...prev,
      errors: err,
    }));
  };
  const isValid = () => {
    let isValid = true;
    try {
      let loc = { ...state };
      let err = loc.errors;
      err.airportCode = "";
      err.locationCode = "";
      err.addressTitle = "";
      err.address = "";
      err.landmark = "";
      err.city = "";
      err.state = "";
      err.country = "";
      err.latitude = "";
      err.longitude = "";
      if (loc.dutyLocatonId === 0) {
        if (!loc.locationCode?.trim()) {
          isValid = false;
          err.locationCode = "Please enter location code";
        }
      }
      if (!mappedAirportCodes?.length) {
        isValid = false;
        err.airportCode = "Please select airport code";
      }
      if (!loc.addressTitle?.trim()) {
        isValid = false;
        err.addressTitle = "Please enter address title";
      }
      if (!loc.address?.trim()) {
        isValid = false;
        err.address = "Please enter the address";
      }
      if (!loc.landmark?.trim()) {
        isValid = false;
        err.landmark = "Please enter landmark";
      }
      if (!loc.city?.trim()) {
        isValid = false;
        err.city = "Please enter city";
      }
      if (!loc.state?.trim()) {
        isValid = false;
        err.state = "Please enter state";
      }
      if (!loc.country?.trim()) {
        isValid = false;
        err.country = "Please enter country";
      }
      if (!loc.latitude?.toString()?.trim()) {
        isValid = false;
        err.latitude = "Please enter latitude";
      }
      if (!loc.longitude?.toString()?.trim()) {
        isValid = false;
        err.longitude = "Please enter longitude";
      }
      loc.errors = err;
      setState((prev) => ({
        ...prev,
        loc,
      }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnSaveCrewLocation = async (e) => {
    e.preventDefault();
    try {
      if (isValid()) {
        let confirmationQuestion =
          state.dutyLocatonId > 0
            ? `Are you sure want to update location ${state.locationCode}?`
            : `Are you sure want to add new location <strong>${state.locationCode}</strong> ?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isLocationSubmitted: true }));
        let request = {};
        request.AirlineCode = sessionStorage.getItem("session_airlineCode");
        request.AirportCodes = mappedAirportCodes;
        request.LocationCode = state.locationCode;
        request.AddressTitle = state.addressTitle;
        request.Address = state.address;
        request.Landmark = state.landmark;
        request.City = state.city;
        request.State = state.state;
        request.Country = state.country;
        request.PostalCode = state.postalCode;
        request.Latitude = state.latitude;
        request.Longitude = state.longitude;
        request.UserName = sessionStorage.getItem("session_userName");
        const requestParams = getRequestParams("POST", request);
        let apiUrl = `${process.env.REACT_APP_API_BASE_URL}CrewActivity/${state.dutyLocatonId}/save-non-fly-activity-location`;
        const response = await fetch(apiUrl, requestParams);
        setState((prev) => ({ ...prev, isLocationSubmitted: false }));
        if (response.status !== 200) {
          toast.error("Opps! Unable to save the data.", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
          return;
        }
        const data = await response.json();

        if (data.isSuccess) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await props.onRefresh();
              await props.onClose();
            }
          });
        } else {
          toast.error(data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
        }
      }
    } catch (err) {
      console.log(err);
      setState((prev) => ({ ...prev, isLocationSubmitted: false }));
    }
  };
  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
        onAfterOpen={async () => {
          await fetchApiOnPageLoad();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.dutyLocatonId === 0
              ? "Add Activity Location"
              : `Update Activity Location [ ${state.locationCode} ] `}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Location Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="locationCode"
                  title="locationCode"
                  placeholder="Enter location code"
                  value={state.locationCode ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  readOnly={state.dutyLocatonId > 0 ? true : false}
                />
                {state.errors.locationCode?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.locationCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Airport<span className="text-danger">*</span>
                </label>
                <DropDownBox
                  value={mappedAirportCodes}
                  valueExpr="airportCode"
                  displayExpr="airportCode"
                  deferRendering={false}
                  showClearButton={true}
                  dataSource={state.dropdownAirportDataSource}
                  onValueChanged={() => {
                    setMappedAirportCodes([]);
                    refLstAirport.current.instance.unselectAll();
                    let err = { ...state.errors, airportCode: "" };
                    setState((prev) => ({ ...prev, errors: err }));
                  }}
                  contentRender={() => {
                    return (
                      <List
                        ref={refLstAirport}
                        //dataSource={state.dropdownAirportDataSource}
                        dataSource={
                          new DataSource({
                            store: state.dropdownAirportDataSource,
                            sort: [
                              "Position",
                              { selector: "isMapped", desc: true },
                            ],
                            sortOrder: "desc",
                            paginate: true,
                            pageSize: 10,
                          })
                        }
                        keyExpr="airportCode"
                        displayExpr="airportName"
                        searchEnabled={true}
                        searchExpr={["airportCode", "airportName"]}
                        searchMode="contains"
                        pageLoadMode="scrollBottom"
                        showSelectionControls={true}
                        selectionMode={"multiple"}
                        indicateLoading={true}
                        onSelectionChanged={() => {
                          try {
                            let err = { ...state.errors, airportCode: "" };
                            setState((prev) => ({ ...prev, errors: err }));
                            if (refLstAirport.current) {
                              setMappedAirportCodes(
                                refLstAirport?.current?.instance?.option(
                                  "selectedItemKeys"
                                ) ?? []
                              );
                            }
                          } catch (error) {
                            console.log("onSelectionChanged", error);
                          }
                        }}
                      />
                    );
                  }}
                  placeholder="Select an item"
                />
                {state.errors.airportCode.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.airportCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Address Title<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="addressTitle"
                  placeholder="Enter address title"
                  value={state.addressTitle ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.addressTitle.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.addressTitle}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Landmark<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="landmark"
                  title="landmark"
                  placeholder="Enter landmark"
                  value={state.landmark ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.landmark?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.landmark}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Latitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="latitude"
                  title="latitude"
                  placeholder="Enter latitude"
                  value={state.latitude ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.latitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.latitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Longitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="longitude"
                  title="longitude"
                  placeholder="Enter longitude"
                  value={state.longitude ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.longitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.longitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  City<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="cityName"
                  title="cityName"
                  placeholder="Enter City"
                  value={state.city ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.city?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.city}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  State<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="stateName"
                  title="stateName"
                  placeholder="Enter State"
                  value={state.state ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.state?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.state}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Country<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="countryName"
                  title="countryName"
                  placeholder="Enter Country"
                  value={state.country ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.country?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.country}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <label>Address</label>
                <div className="input-group mb-2">
                  <textarea
                    style={{ resize: "none" }}
                    className="form-control form-control-sm"
                    name="address"
                    title="address"
                    placeholder="Enter address"
                    rows={3}
                    value={state.address ?? ""}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />
                  <button
                    type="button"
                    title="Search Google"
                    className="btn btn-info"
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        openGooglePlaceSearchModal: true,
                      }));
                    }}
                  >
                    <i className="fab fa-google" />
                  </button>
                </div>
                {state.errors.address?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.address}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div
                style={{
                  height: `290px`,
                  width: `100%`,
                }}
              >
                <Map
                  defaultZoom={16}
                  //center={center}
                  height="100%"
                  width="100%"
                  controls={true}
                  markerIconSrc="https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png"
                  // markerIconSrc={{
                  //   url: `../assets/img/poi/red.png?v=1.0`,
                  // }}
                  markers={[
                    {
                      location: [state.latitude, state.longitude],
                      tooltip: {
                        text: state.address,
                      },
                    },
                  ]}
                  provider="google"
                  apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                ></Map>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-success"
            onClick={async (e) => {
              await handleOnSaveCrewLocation(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isLocationSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;&nbsp;Save
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-custom-gray"
            onClick={() => {
              props.onClose();
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp; Close
            </span>
          </button>
        </div>
      </Modal>
      {state.openGooglePlaceSearchModal && (
        <GooglePlaceSearchComponent
          optionalAutoFillAddress={state.address}
          optionalAutoFillLatitude={state.latitude}
          optionalAutoFillLongitude={state.longitude}
          onChange={(data) => {
            setState((prev) => ({
              ...prev,
              addressTitle: data?.houseApartment ?? "",
              landmark: data?.landmark ?? "",
              address: data?.address ?? "",
              city: data?.cityName ?? "",
              state: data?.stateName ?? "",
              country: data?.countryName ?? "",
              postalCode: data?.postalCode ?? "",
              latitude: data?.latitude ?? "",
              longitude: data?.longitude ?? "",
            }));
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openGooglePlaceSearchModal: false,
            }));
          }}
        />
      )}
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
    </div>
  );
});

const SaveActivityLocationMappingModal = memo((props) => {
  const [state, setState] = useState({
    loadPanelVisible: false,
    isLocationMappingSubmitted: false,
    serviceProviderGridDataSource: [],
    activityLocationSettingsDataSource: [],
  });

  const fetchApiOnPageLoad = async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      await getServiceProvider();
      await getActivityLocationSettings();
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  };

  const getServiceProvider = async () => {
    try {
      let serviceProviderGridDataSource = [];
      for (let index = 0; index < props.mappedAirportCodes.length; index++) {
        const airportCode = props.mappedAirportCodes[index];
        const data = await axiosGet("Account/get-transport-dropdown", {
          airportCode: airportCode,
        });
        if (data.payload?.length > 0) {
          for (let el of data.payload) {
            let transporter = { id: el.id, name: el.name };
            serviceProviderGridDataSource.push(transporter);
          }
        }
      }
      setState((prev) => ({
        ...prev,
        serviceProviderGridDataSource: serviceProviderGridDataSource,
      }));
    } catch (err) {
      console.log("Error in getServiceProvider function", err);
    }
  };

  const getActivityLocationSettings = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let data = await axiosGet("CrewActivity/activity-location-setting", {
        airlineCode: airlineCode,
        locationCode: props.locationCode,
      });
      setState((prev) => ({
        ...prev,
        activityLocationSettingsDataSource: data.payload ?? [],
      }));
    } catch (err) {
      console.log("Error in getActivityLocationSettings function", err);
    }
  };

  const handleOnSaveActivityLocationSettings = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let userName = sessionStorage.getItem("session_userName");
      let confirmationQuestion =
        state.dutyLocatonId > 0
          ? `Are you sure want to update activity location setting [${props.locationCode}]?`
          : `Are you sure want to add new activity location setting <strong>[${props.locationCode}]</strong> ?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );

      if (!isConfirmed) return;
      setState((prev) => ({ ...prev, isLocationMappingSubmitted: true }));

      let activityLocationMappingData = [
        ...new Set(
          state.activityLocationSettingsDataSource.map((el) => {
            return {
              AirlineCode: airlineCode,
              AirportCode: el?.airportCode ?? "",
              LocationCode: el?.locationCode ?? "",
              CrewType: el?.crewType ?? 0,
              transporterId: el?.transporterId ?? 0,
              IsMapped: el?.isMapped ?? false,
              WefDate: el?.wefDate ?? "",
              UserName: userName,
            };
          })
        ),
      ];
      const response = await axiosPost(
        `/CrewActivity/save-activity-location-settings`,
        {
          ActivityLocationMapping: activityLocationMappingData,
        }
      );
      isConfirmed = await showResponseMessageWithErrorInToast(response);
      if (isConfirmed) {
        await getActivityLocationSettings();
      }
      setState((prev) => ({ ...prev, isLocationMappingSubmitted: false }));
    } catch (err) {
      console.log(
        "Error in handleOnSaveActivityLocationSettings function",
        err
      );
      setState((prev) => ({ ...prev, isLocationMappingSubmitted: false }));
    }
  };

  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
        onAfterOpen={async () => {
          await fetchApiOnPageLoad();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.dutyLocatonId === 0
              ? "Add Activity Location Mapping"
              : `Update Activity Location Mapping [${props.locationCode}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <DataGrid
            dataSource={state.activityLocationSettingsDataSource}
            columnsAutoWidth={true}
            showColumnLines={true}
            showRowLines={true}
            showBorders={true}
            rowAlternationEnabled={false}
            allowColumnResizing={true}
          >
            <Editing
              mode="cell"
              allowUpdating={true}
              allowAdding={false}
              allowDeleting={false}
            />
            <Column
              dataField="airportCode"
              caption="Airport Code"
              allowFiltering={false}
              allowSearch={true}
              width={"15%"}
              allowEditing={false}
            />
            <Column
              dataField="crewType"
              caption="Crew Type"
              allowFiltering={false}
              allowSearch={true}
              width={"10%"}
              allowEditing={false}
            />
            <Column
              dataField="transporterId"
              caption="Service Provider"
              //calculateDisplayValue="transporterName"
              width={"35%"}
            >
              <Lookup
                dataSource={state.serviceProviderGridDataSource}
                valueExpr="id"
                displayExpr="name"
              />
            </Column>
            <Column
              dataField="wefDate"
              caption="Wef Date"
              width={"25%"}
              dataType="date"
              format="dd/MM/yyyy"
            ></Column>
            <Column
              dataField="isMapped"
              caption="Mapped"
              allowFiltering={false}
              allowSearch={true}
              width={"10%"}
            />
            <SortByGroupSummaryInfo summaryItem="count" />
            <GroupPanel visible={false} />
            <HeaderFilter visible={true} />
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
              placeholder="Search..."
            />
            <Grouping autoExpandAll={true} />
            <Paging defaultPageSize={10} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={[10, 20, 50]}
              showInfo={true}
              visible={true}
            />
            <Export
              enabled={true}
              allowExportSelectedData={false}
              fileName="ActivityLocationMapping"
            />
          </DataGrid>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-success"
            onClick={async (e) => {
              await handleOnSaveActivityLocationSettings(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isLocationMappingSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;&nbsp;Save
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-custom-gray"
            onClick={() => {
              props.onClose();
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp; Close
            </span>
          </button>
        </div>
      </Modal>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
    </div>
  );
});
